import { Component } from '@angular/core';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  constructor(private layoutService: LayoutService) {}

  ngOnInit() {
    this.layoutService.hideHeader();
  }

  ngOnDestroy(): void {
    this.layoutService.showHeader();
  }
}
